<template>
  <select-field ref="MANUAL_BILLING_DOCUMENT_IN_CART"
                :value=selectedItem
                :items=listItems
                :disabled=readOnly
                :editFieldInfo=editFieldInfo
                :required=required
                :selectText=selectText
                :showMissing=showMissing
                :contextId=contextId
                @updated=setUpdated
                @focus=onFocus
                @error=setError>
  </select-field>
</template>

<script lang="ts">
  import { defineComponent, type PropType } from "vue";
  import { FieldError, FieldStatus, EditFieldType, FieldInfo, EditFieldTheme } from '@/framework/base/components/FieldInfo'
  import SelectField, { SELECT_VALUE, SELECT_TEXT } from '@/framework/base/components/SelectField.vue'
  import Item from '@/framework/base/classes/Item';
  import Ressource from '@/framework/ressource/classes/Ressource';
  import { RessourceGenControl } from '@/generated/ressources/generatedRessources';
  import { GenControl } from '@/generated/ressources/generatedRessources';

  export default defineComponent({
    components: {
      SelectField
    },

    props: {
      value: {
        type: [null, Boolean],
        required: true
      },
      contextId: {
        type: Number,
        required: true
      },
      readOnly: {
        type: Boolean,
      },
      required: {
        type: Boolean,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      showMissing: {
        type: Boolean,
      },
      toggleReset: {
        type: Boolean,
      },
      selectText: {
        type: String,
      }
    },

    created (): void {
      this.initValue = this.value ? this.value : null;
      this.status.objId = this.contextId;
      this.reset = !this.toggleReset;
    },

    data() {
      const initValue: unknown = null;
      const settedValue: unknown = null;
      return {
        initValue,
        settedValue,
        saving: false,
        status: new FieldStatus(false, false, 0),
        reset: true,
        lastContextId: 0,
        labelValue: '',
        listUpdated: false
      }
    },

    computed: {
      ressource () { return RessourceGenControl(GenControl.MANUAL_BILLING_DOCUMENT_IN_CART); },

      editFieldInfo (): FieldInfo {
        const type = EditFieldType.SELECT;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressource, type, precision, mask, format, focus, live, this.theme);
      },

      listItems (): Item[] {
        const res: Item[] = [];
        res.push(new Item(true, "Oui"));
        res.push(new Item(false, "Non"));
        return res;
      },

      selectedItem (): string {
        if (this.lastContextId != this.contextId || this.listUpdated || this.value != this.settedValue) {
          const listItems = this.listItems;
          if (listItems.length > 0) {
            this.setSelectedItem();
          }
        }
        return this.labelValue;
      }
    },

    methods: {
      setSelectedItem() {
        this.initValue = this.value ? this.value : null;
        this.settedValue = this.value ? this.value : null;
        this.status.objId = this.contextId;
        this.lastContextId = this.contextId;
        this.listUpdated = false;
        if (this.value != null) {
          const item = this.listItems.find(a => a.key == this.value);
          if (item) {
            this.labelValue = item.title;
          }
        }
      },

      defaultItem(): Item {
        return new Item(SELECT_VALUE, SELECT_TEXT);
      },

      save (): void {
        this.saving = true;
        this.initValue = this.value;
        this.status.clear(this.contextId);
        this.$emit('status', this.status);
      },

      setUpdated (item: Item): void {
        if (!this.saving) {
          this.settedValue = item.key;
          this.labelValue = item.title;
          this.itemChanged(item.key);
          const updated = (item.key != this.initValue) && (item.key != SELECT_VALUE || this.initValue != null)
          this.updateStatus(updated, this.status.error);
        }
        this.saving = false
      },

      onFocus () {
        this.saving = false;
      },

      setError (value: FieldError): void {
        this.updateStatus(this.status.updated, value.error);
      },

      itemChanged (id: number): void {
        this.$emit('update:value', id);
      },

      updateStatus (updated: boolean, error: boolean): void {
        if (this.status.updated != updated || this.status.error != error) {
          this.status.updated = updated;
          this.status.error = error;
          this.$emit('status', this.status);
        }
      },

      missing (): boolean {
        // @ts-expect-error : generated method
        return this.$refs.MANUAL_BILLING_DOCUMENT_IN_CART.missing();
      },

      touch (): boolean {
        // @ts-expect-error : generated method
        return this.$refs.MANUAL_BILLING_DOCUMENT_IN_CART.touch();
      }
    }
  })
</script>
